import React from "react";

/** Sentinel wordmark that matches the logo:
 *  SENTI (silver/ink) + NEL (electric blue) — Chakra Petch bold, wide tracking. */
export default function Wordmark({
    size = "text-xl",
    tone = "dark", // "dark" (light text) or "light" (dark text)
    className = "",
}) {
    const primary = tone === "dark" ? "text-sn-silver" : "text-sn-ink";
    return (
        <span
            className={`font-brand uppercase tracking-[0.06em] ${size} ${className}`}
        >
            <span className={primary}>SENTI</span>
            <span className="text-sn-blue">NEL</span>
        </span>
    );
}
